export enum Relative {
    Mother = 1,
    Father = 2,
    Son = 3,
    Daughter = 4,
    Brother = 5
}